module.exports = __webpack_public_path__ + "static/media/creighan-contracts-ltd.134cb83a.png";